import React from 'react';
import { ILegalClientInvite } from '../../Interfaces/ILegalClientInvite';
import {
  IconButton,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import {
  Check,
  Close,
  HourglassDisabled,
  HourglassEmpty,
  Link,
} from '@mui/icons-material';
import { ILegalClient } from '../../Interfaces/ILegalClient';

interface IProps {
  invites: ILegalClientInvite[];
}

export const LegalClientsInvitedTable: React.FC<IProps> = ({ invites }) => {
  const getLegalClientTsx = (
    idLegalClient: number | null,
    legalClintArray: ILegalClient[]
  ) => {
    let testObject = legalClintArray.find(
      lc => lc.idLegalClient === idLegalClient
    );
    if (testObject) {
      return (
        <>
          {`${testObject.FirstName} ${testObject.LastName}`}
          <IconButton
            href={`/legalclient/${testObject.idLegalClient}`}
            target='_blank'
          >
            <Link />
          </IconButton>
        </>
      );
    } else {
      return <>-</>;
    }
  };

  return (
    <>
      <Table size='small'>
        <TableHead>
          <TableCell width={60}>Status</TableCell>
          <TableCell width={160}>Datum</TableCell>
          <TableCell>Von</TableCell>
          <TableCell>Ziel</TableCell>
        </TableHead>
        <TableHead>
          {invites.length === 0 && (
            <TableRow>
              <TableCell colSpan={4}>
                <i>Keine Einträge vorhanden.</i>
              </TableCell>
            </TableRow>
          )}
          {invites.map(invite => (
            <TableRow>
              <TableCell>
                {invite.isAssumed === null && invite.expired == false ? (
                  <Tooltip title='Einladung zum Vorgang offen'>
                    <HourglassEmpty />
                  </Tooltip>
                ) : invite.isAssumed == true ? (
                  <Tooltip title='Einladung zum Vorgang angenommen'>
                    <Check />
                  </Tooltip>
                ) : invite.isAssumed == false ? (
                  <Tooltip title='Einladung zum Vorgang abgelehnt'>
                    <Close />
                  </Tooltip>
                ) : (
                  <Tooltip title='Einladung zum Vorgang abgelaufen'>
                    <HourglassDisabled />
                  </Tooltip>
                )}
              </TableCell>
              <TableCell>
                {new Date(invite.Timestamp).toLocaleString()}
              </TableCell>
              <TableCell>
                {getLegalClientTsx(
                  invite.From_idLegalClient,
                  invite.LegalClients
                )}
              </TableCell>
              <TableCell>
                {invite.Email !== null && invite.Email !== ''
                  ? `E-Mail: ${invite.Email}`
                  : invite.From_idLegalClient ===
                      Number(invite.To_idLegalClient)
                    ? 'Bestätigung der Vorgangsübermittlung'
                    : getLegalClientTsx(
                        invite.To_idLegalClient,
                        invite.LegalClients
                      )}
              </TableCell>
            </TableRow>
          ))}
        </TableHead>
      </Table>
    </>
  );
};
